import { render, staticRenderFns } from "./_BackgroundImageContent.vue?vue&type=template&id=22906eec&scoped=true&"
import script from "./_BackgroundImageContent.vue?vue&type=script&lang=js&"
export * from "./_BackgroundImageContent.vue?vue&type=script&lang=js&"
import style0 from "./_BackgroundImageContent.vue?vue&type=style&index=0&id=22906eec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22906eec",
  null
  
)

export default component.exports